/*
IMPORTANT NOTE: don't remove from first line
import dictionary from "configs/dictionary";
WHEN GATSBY RUNS WE NEED TO IMPORT THE DICTIONARY AS FIRST FILE 
*/
import dictionary from "configs/dictionary";

import { DynamicProps } from "types/pages/types";
import { HeadConfig } from "types/types";
import { graphql } from "gatsby";
import { logDebug } from "helpers/generic";
import Head from "components/Head";
import Layout from "components/Layouts/LayoutDefault";
import React from "react";
import recursiveData from "utilities/recursiveData";
import recursiveRender from "utilities/recursiveRender";

const PageTemplate = (props: DynamicProps) => {
  logDebug("p-> dyna", props);
  const { data, pageContext, location } = props;
  const { contentfulPageV2, allContentfulFaqDetailV2 } = data;
  const {
    hasBreadcrumb,
    template,
    settings,
    seo,
    menuNavigation,
    hasScrollAnimation,
    bannerApp,
    bannerPopup,
    jsonLd,
    menu,
  } = contentfulPageV2;
  const { strips } = template[0];
  const { pageHrefLang, lang, breadcrumb } = pageContext;
  const headConfig: HeadConfig = {
    pageHrefLang,
    lang,
    robots: settings[0].metaRobots,
    seo: seo[0],
    location,
    jsonLd: jsonLd?.internal.content,
  };
  logDebug("page-> ", contentfulPageV2);
  logDebug("strips-> ", strips);
  logDebug("constex ", pageContext);

  const stripWithUpdateData = recursiveData({
    data: strips,
    typename: "ContentfulFaqListPreviewV2",
    faqs: allContentfulFaqDetailV2.nodes,
  });

  return (
    <>
      <Head headConfig={headConfig} />
      <Layout
        bannerApp={bannerApp?.[0]}
        bannerPopup={bannerPopup?.[0]}
        headConfig={headConfig}
        header={menuNavigation}
        breadcrumb={hasBreadcrumb ? breadcrumb : undefined}
        settings={settings[0]}
        hasScrollAnimation={hasScrollAnimation}
        dataJsonMenu={menu}
      >
        {recursiveRender({ dictionary, cfComponent: stripWithUpdateData })}
      </Layout>
    </>
  );
};

export default PageTemplate;

export const pageQuery = graphql`
  query ($id: String!, $lang: String!) {
    contentfulPageV2(id: { eq: $id }, node_locale: { eq: $lang }) {
      ...PageV2
    }
    allContentfulFaqDetailV2 {
      nodes {
        ... on ContentfulFaqDetailV2 {
          ...FaqDetailPreviewV2
        }
      }
    }
  }
`;
